import { useState, useRef, useEffect } from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';

const Topbar = () => {
    const { user, signOut } = useAuthContext();
    const location = useLocation();
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleLogout = () => {
        setMenuOpen(false);
        signOut();
        navigate('/');
    };

    const handleMyAccount = () => {
        setMenuOpen(false);
        navigate('/dashboard/account');
    };

    const pageTitles = {
        '/dashboard/reports': 'Reports',
        '/dashboard/history': 'History',
        '/dashboard/users': 'Manage Users',
        '/dashboard/account': 'My Account',
    } as { [key: string]: string };

    const currentTitle = pageTitles[location.pathname] || 'Dashboard';

    return (
        <header className="bg-white border-b border-gray-200 py-4 px-6 flex items-center justify-between">
            <div>
                <h1 id="dashboardTitle" className="text-xl font-semibold text-gray-800">{currentTitle}</h1>
            </div>
            <div className="flex items-center space-x-4">
                {/* Bell */}
                <div className="relative">
                    <button className="text-gray-500 hover:text-gray-700">
                        <i className="fas fa-bell"></i>
                    </button>
                    <span className="absolute top-0 right-0 h-2 w-2 rounded-full bg-red-500"></span>
                </div>

                {/* User menu */}
                <div className="relative" ref={menuRef}>
                    <button
                        className="flex items-center space-x-2 hover:opacity-80 transition"
                        onClick={() => setMenuOpen(v => !v)}
                    >
                        <div className="h-8 w-8 rounded-full gradient-bg flex items-center justify-center">
                            <i className="fas fa-user text-white text-sm"></i>
                        </div>
                        <span className="text-gray-700">{user?.displayName || 'User'}</span>
                        <i className={`fas fa-chevron-down text-gray-400 text-xs transition-transform ${menuOpen ? 'rotate-180' : ''}`}></i>
                    </button>

                    {menuOpen && (
                        <div className="absolute right-0 top-full mt-2 w-44 bg-white rounded-xl shadow-lg border border-gray-100 py-1 z-50">
                            <button
                                onClick={handleMyAccount}
                                className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition"
                            >
                                <i className="fas fa-user-circle text-gray-400 w-4"></i>
                                My Account
                            </button>
                            <div className="border-t border-gray-100 my-1" />
                            <button
                                onClick={handleLogout}
                                className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition"
                            >
                                <i className="fas fa-sign-out-alt text-red-400 w-4"></i>
                                Logout
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Topbar;
